/* eslint-disable camelcase */
import { csv } from "d3-fetch";
import dayjs from "dayjs";
import PRISON_DATA from "../data/pa-prisons.csv";

const cleaner = ({
  as_of_date,
  total_prisoner_cases,
  total_prisoner_deaths,
  total_staff_cases,
  total_staff_deaths,
}) => ({
  date: dayjs(as_of_date, "MM/DD/YY").unix(),
  totalPrisonerCases: +total_prisoner_cases,
  totalPrisonerDeaths: +total_prisoner_deaths,
  totalStaffCases: +total_staff_cases,
  totalStaffDeaths: +total_staff_deaths,
});

const loadData = () => {
  /* Fetch and parse files. */
  return Promise.all([csv(PRISON_DATA, cleaner)]).then(([prisonData]) => {
    const data = {};
    prisonData.sort((a, b) => a.date - b.date);

    data.prisonData = prisonData;
    return data;
  });
};

export default loadData;
